import React, { useState, useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PageView = ({ slug, onBack }) => {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios.get(`${BACKEND_URL}/api/pages/${slug}`)
      .then(r => { setPage(r.data); setLoading(false); })
      .catch(() => { setError(true); setLoading(false); });
  }, [slug]);

  if (loading) return <div style={{ textAlign: 'center', padding: 40, color: '#555' }}>Loading...</div>;
  if (error || !page) return (
    <div style={{ textAlign: 'center', padding: 60, color: '#555' }}>
      <h3 style={{ color: '#888', marginBottom: 8 }}>Page not found</h3>
      <button className="vp-back" onClick={onBack}><ArrowLeft size={15} /> Back</button>
    </div>
  );

  return (
    <div>
      <button className="vp-back" onClick={onBack} style={{ marginBottom: 16 }}>
        <ArrowLeft size={15} /> Back
      </button>
      <div className="story-page">
        <h1 className="story-page-title">{page.title}</h1>
        <div className="story-page-content" dangerouslySetInnerHTML={{ __html: page.content || '' }} />
      </div>
    </div>
  );
};

export default PageView;
